import NotificationFollowing from "desktop/components/notifications/notification_following";
import NotificationInbox from "desktop/components/notifications/notification_inbox";
import $ from 'jquery';

const NotificationMenu = {
  you: null,
  following: null,

  ui: {
    root: 'div.notifications',
    you: 'div.notifications .activity-list.activity-list--you',
    icon: '.notifications__icon',

    sidebar: '.sidebar__notifications',

    ujs: {
      read:  'a.notifications__ujs--read'
    }
  },

  new(options) {
    if (options === undefined) { options = {}; }
    if (options.dependencies === undefined) { options.dependencies = true; }

    const object = Object.create(NotificationMenu);

    if (options.dependencies) {
      object.bindClick();
      object.bindTab();

      this.initYou();

      object.following = new NotificationFollowing({parent: object});
      object.following.init();
    }

    return object;
  },

  initYou(){
    this.you = new NotificationInbox({
      $element: $(this.ui.you),
      setParentCount: this.setParentYouCount.bind(this),
      setParentLoaded: this.setParentYouLoaded.bind(this),
      setParentUnread: this.setParentYouUnread.bind(this)
    });

    this.you.init();
  },

  setParentYouCount(value){
    $(this.ui.root).attr("data-you-count", value); 
  },

  setParentYouLoaded(value){
    $(this.ui.root).attr("data-you-loaded", value); 
  },

  setParentYouUnread(value){
    $(this.ui.root).attr("data-you-unread", value);
  },

  bindClick() {
    $(this.ui.icon).on('click', () => {
      this.following.load();
      this.you.triggerImpression();
    });
  },

  bindTab() {
    $('.site-header__dropdown--notification .site-header__dropdown__tab-nav__link').on({
      "click"(e) {
          e.stopPropagation();
          e.preventDefault();
          $(this).tab('show');
        }
    });    
  },

  count() {
    return $(this.ui.root).data('count');
  },

  read() {
    if (this.count() > 0) {
      this.triggerUJSRead();
      this.resetCount();
    }
  },

  resetCount() {
    this.setCount(0);
  },

  setCount(value) {
    $(`${this.ui.root}, ${this.ui.sidebar}`).attr('data-count', value);
  },

  triggerUJSRead() {
    $.ajax({
      url: "/notifications/mark_as_read.json",
      method: 'POST',
    });
  },
};

export default NotificationMenu;
